import React from 'react';
import FieldDisplay from '../../field/display/FieldDisplay';
import ResultLinks from './ResultLinks';
import ResultSelect from './ResultSelect';
import ResultMedia from './ResultMedia';

const SearchResultsMosaic = ({objects, displayLink, addToCart, removeFromCart, selectable,
  addLink, defaultImage, isPublicUser }) => {
  let loadedImageCount = 0;
  const displayedObjectsCount = objects.length;

  if (!objects || !Array.isArray(objects) || objects.length < 1) {
    return null;
  }

  const imageLoadedCallback = () => {
    loadedImageCount++;
    if (loadedImageCount >= displayedObjectsCount) {
      window.parent?.resizeIframe();
    }
  };

  return (
    <div className="result-pane result-pane--mosaic">
      {
        objects.map((object, i) => (
          <div key={i} className="tile">
            <div className="tile__image">
              <ResultMedia image={object.image} defaultImage={defaultImage} onImageLoad={imageLoadedCallback} />
            </div>
            <div className="tile__content">
              <div className="tile__status">
                <ResultSelect selectable={selectable && !addLink && !isPublicUser} object={object} />
              </div>
              <div className="tile__desc">
                {
                  object.fields.map((field, index) => (
                    <FieldDisplay field={field} key={index} />
                  ))
                }
              </div>
              <ResultLinks object={object} displayLink={displayLink} 
                addToCart={addToCart} removeFromCart={removeFromCart} addLink={addLink}  isPublicUser={isPublicUser}/>
            </div>
          </div>
        ))
      }
    </div>
  );
};

export default SearchResultsMosaic;